import { useTranslation } from "react-i18next";
import { formattedDate } from "../../components/formatted/FormattedDateAndTime";
import {
  faFilePowerpoint,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DocumentRow = ({ data }) => {
  const { t } = useTranslation();

  const getIconForExtension = (ext) => {
    switch (ext) {
      case "pptx":
        return faFilePowerpoint;
      case "pdf":
        return faFilePdf;
      case "docx":
        return faFileWord;
      case "xlsx":
        return faFileExcel;
      default:
        return faFile;
    }
  };

  return (
    <div className="table-standard-row">
      <div
        className="table-standard-row-cell min-w-0"
        data-label={t("Name")}
        title={data?.name || ""}
      >
        <span className="flex items-center gap-2 min-w-0 w-full">
          <FontAwesomeIcon
            icon={getIconForExtension(data.extension)}
            className="text-lg text-[#d24726] shrink-0"
          />
          <span className="table-standard-row-cell-truncate">
            {data?.name || "—"}
          </span>
        </span>
      </div>
      <div
        className="table-standard-row-cell text-sm text-[#5e5e5e] min-w-0"
        data-label={t("Creation date")}
      >
        <span className="table-standard-row-cell-truncate">
          {formattedDate(data?.date, t)}
        </span>
      </div>
      <div className="table-standard-row-cell table-standard-row-actions">
        <a
          href={data?.url}
          target="_blank"
          rel="noopener noreferrer"
          download
          className="button-action-wrapper"
          onClick={(event) => event.stopPropagation()}
        >
          <i className="fas fa-download button-action" aria-hidden />
        </a>
      </div>
    </div>
  );
};

export default DocumentRow;
